import ApplicationPaymentsDetailsFeature from "../features/ApplicationPaymentsDetails";

export default function ApplicationPaymentsDetails() {
  return <ApplicationPaymentsDetailsFeature />;
}
